// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as jquery from './assets/js/jquery-1.12.1.min.js'
import * as bootstrapjs from './assets/js/bootstrap.min.js'
import * as common from './assets/js/common.js'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import ProgressBar from 'vuejs-progress-bar'
import i18n from './i18n'
import VueTextareaAutosize from 'vue-textarea-autosize'
import PortalVue from 'portal-vue'
import UserActionLogger from './core/library/UserActionLogger'
import {REQUEST_URL} from './_config'

import { vfmPlugin } from 'vue-final-modal'
import {getUserData} from './helpers'

import VueChatScroll from 'vue-chat-scroll'

Vue.config.productionTip = false
axios.baseURL = REQUEST_URL
axios.baseOriginURL = REQUEST_URL
Vue.prototype.$logger = new UserActionLogger()

let user = getUserData()
if (user) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.Token
  Vue.prototype.$logger.userID = user.ID
}

Vue.prototype.$axios = axios
Vue.use(VueAxios, axios)
Vue.use(ProgressBar)
Vue.use(VueTextareaAutosize)
Vue.component('paginate', Paginate)
Vue.component('multiselect', Multiselect)
Vue.use(PortalVue)
Vue.use(VueChatScroll)

Vue.use(vfmPlugin({
  key: '$vfm',
  componentName: 'VueFinalModal',
  dynamicContainerName: 'ModalsContainer'
}))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// /src/main.js